export const metaPrefix = '_meta_';
export type MetaPrefix = typeof metaPrefix;
